import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addexpensetype',
  templateUrl: './addexpensetype.component.html',
  styleUrls: ['./addexpensetype.component.css']
})
export class AddexpensetypeComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "Expensetype";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  expensetypeColl: any = [];
  expensetypeBO: any = {};

  expensetypeid: number = 0

  expensetypeform = new FormGroup({
    expensetypeid: new FormControl(0),
    expensetypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.expensetypeid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }


    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.expensetypeform.reset();
      this.fnInitializeFormGroup();

      if (this.expensetypeid > 0) {
        this.fngetExpenseType();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.expensetypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }

  fnInitializeFormGroup() {
    this.expensetypeform.setValue({
      expensetypeid: 0,
      expensetypename: '',
      inactive: false
    })
  }

  //Get 
  fngetExpenseType() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'expensetypeid': this.expensetypeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getExpenseType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.expensetypeColl = res.json().result;
            var editdata = this.expensetypeColl[0];
            this.fnEditMode(editdata);
            this.expensetypeBO=editdata;
          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.expensetypeform.valid) {
        //Check
        this.saveloading = true;


        var data = {
          'expensetypeid': this.expensetypeid,
          'expensetypename': this.expensetypeform.get('expensetypename').value,
          'inactive': this.expensetypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckExpenseType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.expensetypeform.get('expensetypeid').value > 0) {
                  //Update 
                  this.fnSetExpenseType(data);
                }
                else {
                  //Insert 
                  this.fnInsertExpenseType(data);
                }
              }
              else {
                if (_checkresult === "name") { this.saveloading = false;

                  this.expensetypeform.controls['expensetypename'].setErrors({ 'notfound': true });
                }
              }
            }
            else { this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => { this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) { this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertExpenseType(data) {

    this.appService.fnInsertExpenseType(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new expensetype has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.expensetypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetExpenseType(data) {

    this.appService.fnSetExpenseType(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The expensetype has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.expensetypeid, data.expensetypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/ExpenseType']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.expensetypeform.setValue({
      expensetypeid: deptBO.expensetypeid,
      expensetypename: deptBO.expensetypename,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
